import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Language } from '@/constants/i18n';
import type { OutputType, QualityPreset, SnapshotFormat } from '@/types';
import { generateId } from '@/utils/misc';

interface SettingsState {
  language: Language;
  notificationsEnabled: boolean;
  defaultOutput: OutputType;
  defaultQuality: QualityPreset;
  snapshotInterval: number;
  snapshotFormat: SnapshotFormat;
  /** Stable anonymous id used to correlate guest jobs. */
  guestId: string;
  setLanguage: (language: Language) => void;
  setNotificationsEnabled: (enabled: boolean) => void;
  setDefaultOutput: (output: OutputType) => void;
  setDefaultQuality: (quality: QualityPreset) => void;
  setSnapshotInterval: (interval: number) => void;
  setSnapshotFormat: (format: SnapshotFormat) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      language: 'en',
      notificationsEnabled: false,
      defaultOutput: 'video',
      defaultQuality: 'best',
      snapshotInterval: 3,
      snapshotFormat: 'jpg',
      guestId: generateId(),
      setLanguage: (language) => set({ language }),
      setNotificationsEnabled: (notificationsEnabled) => set({ notificationsEnabled }),
      setDefaultOutput: (defaultOutput) => set({ defaultOutput }),
      setDefaultQuality: (defaultQuality) => set({ defaultQuality }),
      setSnapshotInterval: (snapshotInterval) => set({ snapshotInterval }),
      setSnapshotFormat: (snapshotFormat) => set({ snapshotFormat }),
    }),
    { name: 'dmmt-settings' }
  )
);
